"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = void 0;
const preact_1 = require("preact");
const Loading_1 = require("./Loading");
const FreeMode_1 = require("./FreeMode");
const ReplayMode_1 = require("./ReplayMode");
const Fullscreen_1 = require("../Fullscreen");
const FilePicker_1 = require("../FilePicker");
const Game_1 = require("../Game");
const Root_style_1 = require("./Root.style");
class Root extends preact_1.Component {
    constructor(props) {
        super(props);
        this.node = null;
        this.fadeOut = 0;
        this.onPointerLockChange = () => {
            if (document.pointerLockElement === this.props.root) {
                this.props.game.pointerLocked = true;
            }
            else {
                this.props.game.pointerLocked = false;
                this.props.game.mouse.delta[0] = 0;
                this.props.game.mouse.delta[1] = 0;
                this.props.game.keyboard.keys.fill(0);
            }
        };
        this.onContextMenu = (e) => {
            e.preventDefault();
            if (this.props.game.pointerLocked) {
                document.exitPointerLock();
            }
        };
        this.onWindowClick = () => {
            this.setState({ isActive: false });
        };
        this.onRootClick = (e) => {
            e.stopPropagation();
            this.setState({ isActive: true });
            this.fadeReset();
        };
        this.onKeyDown = (e) => {
            if (!this.state.isActive) {
                return;
            }
            const game = this.props.game;
            switch (e.which) {
                case 70: {
                    if (Fullscreen_1.Fullscreen.isInFullscreen()) {
                        Fullscreen_1.Fullscreen.exit();
                    }
                    else {
                        Fullscreen_1.Fullscreen.enter(this.props.root);
                    }
                    this.fadeReset();
                    break;
                }
                case 86: {
                    game.soundSystem.toggleMute();
                    this.fadeReset();
                    break;
                }
                case 38: {
                    game.soundSystem.setVolume(game.soundSystem.getVolume() + 0.05);
                    this.fadeReset();
                    break;
                }
                case 40: {
                    game.soundSystem.setVolume(game.soundSystem.getVolume() - 0.05);
                    this.fadeReset();
                    break;
                }
                case 74:
                case 37: {
                    game.seekAllBySeconds(-5);
                    this.fadeReset();
                    break;
                }
                case 76:
                case 39: {
                    game.seekAllBySeconds(5);
                    this.fadeReset();
                    break;
                }
                case 75:
                case 32: {
                    if (this.props.game.comparisonReplays.length === 0) {
                        return;
                    }
                    if (!game.isPlaybackPlaying()) {
                        game.playAll();
                    }
                    else {
                        game.pauseAll();
                    }
                    break;
                }
                case 67:
                    game.toggleCameraMode();
                    break;
                case 81:
                    game.cyclePov(-1);
                    break;
                case 69:
                    game.cyclePov(1);
                    break;
                case 219:
                    game.speedDownAll();
                    break;
                case 221:
                    game.speedUpAll();
                    break;
                case 77:
                    game.toggleMinimap();
                    break;
                case 79:
                    (0, FilePicker_1.showFilePicker)();
                    break;
            }
        };
        this.onModeChange = () => {
            this.forceUpdate();
        };
        this.onLoadStart = () => {
            this.setState({ isLoading: true });
        };
        this.onLoadEnd = () => {
            this.setState({ isLoading: false });
        };
        this.onTitleChange = (title) => {
            this.setState({ title });
        };
        this.onSpeedChange = (speed) => {
            this.setState({ speed });
        };
        this.onFpsChange = (fps) => {
            this.setState({ fps });
        };
        this.onButtonsChange = (buttons) => {
            this.setState({ buttons });
        };
        this.onStrafesChange = (strafes) => {
            this.setState({ strafes });
        };
        this.onGravityChange = (gravity) => {
            this.setState({ gravity });
        };
        this.onMouseEnter = () => {
            this.setState({ isMouseOver: true });
            this.fadeReset();
        };
        this.onMouseMove = () => {
            if (this.state.isMouseOver && !Fullscreen_1.Fullscreen.isInFullscreen()) {
                this.fadeReset();
            }
        };
        this.onMouseLeave = () => {
            this.setState({
                isMouseOver: false,
                isVisible: false
            });
            clearTimeout(this.fadeOut);
            this.fadeOut = 0;
        };
        this.fadeReset = () => {
            if (!this.state.isVisible) {
                this.setState({ isVisible: true });
            }
            clearTimeout(this.fadeOut);
            this.fadeOut = setTimeout(() => {
                this.setState({ isVisible: false });
                this.fadeOut = 0;
            }, 5000);
        };
        this.onScreenClick = () => {
            switch (this.props.game.mode) {
                case Game_1.PlayerMode.REPLAY: {
                    const player = this.props.game.player;
                    if (!player.isPlaying || player.isPaused) {
                        this.props.game.playAll();
                    }
                    else {
                        this.props.game.pauseAll();
                    }
                    break;
                }
                case Game_1.PlayerMode.FREE: {
                    this.props.root.requestPointerLock();
                    break;
                }
            }
        };
        this.onScreenDblClick = () => {
            if (Fullscreen_1.Fullscreen.isInFullscreen()) {
                Fullscreen_1.Fullscreen.exit();
            }
            else {
                Fullscreen_1.Fullscreen.enter(this.props.root);
            }
        };
        this.state = {
            title: props.game.title,
            speed: props.game.speed,
            fps: props.game.fps,
            buttons: props.game.buttons,
            strafes: props.game.strafes,
            gravity: '',
            isActive: false,
            isLoading: false,
            isMouseOver: false,
            isVisible: false
        };
    }
    componentDidMount() {
        if (!this.node) {
            return;
        }
        const game = this.props.game;
        const root = this.props.root;
        this.node.appendChild(game.getCanvas());
        this.offLoadStart = game.events.on('loadstart', this.onLoadStart);
        this.offLoad = game.events.on('load', this.onLoadEnd);
        this.offModeChange = game.events.on('modechange', this.onModeChange);
        this.offTitleChange = game.events.on('titlechange', this.onTitleChange);
        this.offSpeedChange = game.events.on('speedchange', this.onSpeedChange);
        this.offFpsChange = game.events.on('fpschange', this.onFpsChange);
        this.offButtonsChange = game.events.on('buttonschange', this.onButtonsChange);
        this.offStrafesChange = game.events.on('strafeschange', this.onStrafesChange);
        this.offGravityChange = game.events.on('gravitychange', this.onGravityChange);
        root.addEventListener('click', this.onRootClick);
        window.addEventListener('click', this.onWindowClick);
        window.addEventListener('keydown', this.onKeyDown);
        document.addEventListener('pointerlockchange', this.onPointerLockChange, false);
        root.addEventListener('mouseover', this.onMouseEnter);
        root.addEventListener('mousemove', this.onMouseMove);
        root.addEventListener('mouseout', this.onMouseLeave);
        root.addEventListener('contextmenu', this.onContextMenu);
    }
    componentWillUnmount() {
        const root = this.props.root;
        this.offLoadStart && this.offLoadStart();
        this.offLoad && this.offLoad();
        this.offModeChange && this.onModeChange();
        this.offTitleChange && this.offTitleChange();
        this.offSpeedChange && this.offSpeedChange();
        this.offFpsChange && this.offFpsChange();
        this.offButtonsChange && this.offButtonsChange();
        this.offStrafesChange && this.offStrafesChange();
        this.offGravityChange && this.offGravityChange();
        root.removeEventListener('click', this.onRootClick);
        window.removeEventListener('click', this.onWindowClick);
        window.removeEventListener('keydown', this.onKeyDown);
        document.removeEventListener('pointerlockchange', this.onPointerLockChange, false);
        root.removeEventListener('mouseover', this.onMouseEnter);
        root.removeEventListener('mousemove', this.onMouseMove);
        root.removeEventListener('mouseout', this.onMouseLeave);
        root.removeEventListener('contextmenu', this.onContextMenu);
    }
    render() {
        const { game } = this.props;
        const { isVisible, speed, fps, buttons, strafes, gravity, isLoading, isMouseOver } = this.state;
        const isSpeedVisible = game.isSpeedVisible && speed;
        const isFpsVisible = game.isFpsVisible && fps;
        const isButtonsVisible = game.isButtonsVisible && buttons;
        const isStrafesVisible = game.isStrafesVisible && buttons;
        const imageSrc = `/img/${gravity}.png`;
        return ((0, preact_1.h)("div", { class: isVisible ? Root_style_1.RootStyle.rootVisible : Root_style_1.RootStyle.root },
            (0, preact_1.h)(Loading_1.Loading, { game: game, visible: isLoading }),
            (0, preact_1.h)("div", { class: Root_style_1.RootStyle.screen, ref: node => (this.node = node), onClick: this.onScreenClick, onDblClick: this.onScreenDblClick },
                gravity ? (0, preact_1.h)("img", { class: Root_style_1.RootStyle.modelVisible, src: imageSrc }) : '',
                (0, preact_1.h)("pre", { class: Root_style_1.RootStyle.keysVisible },
                    isStrafesVisible ? `${strafes}\n\n` : '',
                    isButtonsVisible ? `${buttons}` : '',
                    isSpeedVisible ? `\n${speed} ups` : '',
                    isFpsVisible ? `\n${fps} fps` : '')),
            game.mode === Game_1.PlayerMode.FREE && game.comparisonReplays.length === 0 ? ((0, preact_1.h)(FreeMode_1.FreeMode, { class: isVisible ? Root_style_1.RootStyle.controlsVisible : Root_style_1.RootStyle.controls, game: game, root: this.props.root })) : ((0, preact_1.h)(ReplayMode_1.ReplayMode, { class: isVisible ? Root_style_1.RootStyle.controlsVisible : Root_style_1.RootStyle.controls, game: game, root: this.props.root, visible: isMouseOver }))));
    }
}
exports.Root = Root;
